<template>
  <v-tooltip location="top">
    <template #activator="{ props: tooltipProps }">
      <div class="project-card" v-bind="tooltipProps" @click="moveToProjectPage()">
        <div class="project-card__title">{{ project.name }}</div>
        <div v-if="project.description" class="project-card__description">{{ project.description }}</div>
      </div>
    </template>
    <div><strong>{{ projectUid }}</strong></div>
    <div>{{ project.description }}</div>
  </v-tooltip>
</template>

<script>
import { event } from 'vue-gtag';

export default {
  props: {
    project: {
      type: Object,
      default: () => {},
    },
    showMenu: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['clicked', 'clone-project'],
  computed: {
    projectUid() {
      return this.project.id ? `p-${Number(this.project.id).toString(16)}` : '';
    },
  },
  methods: {
    moveToProjectPage() {
      event('public_project_clicked', {
        category: 'public_project',
        label: 'User clicked on public project',
        value: this.project.name,
      });
      this.$router.push({ name: 'public.project', params: { projectId: Number(this.project.id).toString(16) } });
    },
    handleClone() {
      this.$emit('clone-project', this.project.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.project-card {
  padding: 8px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  cursor: pointer;
  background-color: #ffffff;
  transition: all 0.2s ease;
  min-width: 240px;
  max-width: 300px;

  &:hover {
    border-color: #0066cc;
    box-shadow: 0 2px 8px rgba(0, 102, 204, 0.1);
  }

  &__title {
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 4px;
    color: #0066cc;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__description {
    font-size: 12px;
    color: #666;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
